import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import classNames from 'classnames';

import { RootState } from '../../../reducers';
import * as _actionsJourney from '../../../actions/journey1';
import * as _actionsBasket from '../../../actions/basket';
import { Button, EButtonType, PackagesInput } from '@repo/apg-ui';
import './Step7.scss';
import * as actions from '../../../actions/index';
import SpinnerV2 from '../../../components/SpinnerV2';
import ProductsTable from '../../../components/ProductsTable';
import { prepareProposalsPayload } from '../../../utils/payloads';
import MapContainer from '../../../components/MapContainer';
import { formatNumber, replaceUmlauts } from '../../../utils/react';
import { defined } from '../../../utils/variableEvaluation';
import { cutString } from '../../../utils/string';
import { ReactComponent as LocationIcon } from '../../../assets/icons/icons8-place_marker.svg';
import { ReactComponent as ListIcon } from '../../../assets/icons/icons8-list.svg';
import { ReactComponent as IconTarget } from '../../../assets/icons/target.svg';
import { ReactComponent as IconArrowRight } from '../../../assets/icons/black-arrow-right.svg';
import { useNavigate } from 'react-router';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';

interface Props {
  actionsJourney: typeof _actionsJourney;
  actionsBasket: typeof _actionsBasket;
  baskets: any;
  fetchProduct: any;
  availableAttributesJ1: any;
  intl: any;
  locales: any;
  possibleBookingDates: any;
  postProposals: any;
  proposals: any;
  proposalsError: any;
  proposalsObj: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  validationMessageConfig: any;
  stateMapView: boolean;
  dispatch: Dispatch;
}

const Step7 = (props: Props) => {
  // const tabsContainerRef = createRef<HTMLDivElement>();
  const tabsContainerRef = useRef(null);

  const [loading, setLoading] = React.useState(false);
  const [sort, setSort] = React.useState({ name: 0, price: 1 });
  const [currentSort, setCurrentSort] = React.useState('price');
  const [mapView, setMapView] = React.useState(false);
  const [basketLoading, setBasketLoading] = React.useState(false);
  const [selectedBasketProposal, setSelectedBasketProposal] = React.useState(props.userDataEC.selectedBasketProposal);
  const [tabJ1, setTabJ1] = React.useState(0);
  const [tabJ1Name, setTabJ1Name] = React.useState('');
  const [productTabsElements, setProductTabsElements] = React.useState({});
  const [centerCordsMap, setCenterCordsMap] = React.useState({});
  const [tabsScroll, setTabsScroll] = React.useState({
    scrollWidthParent: 0,
    scrollWidth: 0,
    scrollLeft: 0,
  });

  const navigate = useNavigate();

  // constructor(props: any) {
  //     super(props);
  //     let firstKey = '';
  //     if (this.props.baskets) {
  //         firstKey = Object.keys(this.props.baskets)[0];
  //     }
  //
  //     this.state = {
  //         loading: false,
  //         sort: { name: 0, price: 1 },
  //         currentSort: 'price',
  //         mapView: false,
  //         basketLoading: false,
  //         selectedBasketProposal: this.props.userDataEC.selectedBasketProposal || firstKey,
  //         tabJ1: 0,
  //         tabJ1Name: '',
  //         productTabsElements: {},
  //         centerCordsMap: {},
  //         tabsScroll: {
  //             scrollWidthParent: 0,
  //             scrollWidth: 0,
  //             scrollLeft: 0,
  //         },
  //     };
  // }

  useEffect(() => {
    const ref = tabsContainerRef.current;
    ref.addEventListener('scroll', () => handleScroll(ref.scrollLeft));
    let firstKey = '';

    if (props.baskets) {
      firstKey = Object.keys(props.baskets)[0];
    }

    setSelectedBasketProposal(props.userDataEC.selectedBasketProposal || firstKey);

    document.body.classList.add('step7');

    const payload = prepareProposalsPayload(props.userDataEC);

    if (!defined(props.userDataEC.selectedBasketProposal) || props.userDataEC.shouldCreateNewBasketJ1) {
      generateProposals(payload).then((proposals) => {
        const firstKey = 0;
        if (proposals.length) {
          props.actionsBasket.chooseBasket({
            proposal: proposals[firstKey],
            id: proposals[firstKey].basket,
          });
          props.fetchProduct(true);
          setLoading(false);
          const proposal = proposals[firstKey] ? proposals[firstKey].basket.toString() : null;
          setSelectedBasketProposal(proposal);
          getBasketContent(proposal);
        }
      });
    } else {
      const proposals = props.proposals;
      const firstKey = 0;
      if (proposals.length) {
        getBaskets(proposals).then(() => {
          props.actionsBasket.chooseBasket({
            proposal: proposals[firstKey],
            id: proposals[firstKey].basket,
          });
          props.fetchProduct(true);
          setLoading(false);
          const proposal = proposals[firstKey] ? proposals[firstKey].basket.toString() : null;
          setSelectedBasketProposal(proposal);
          getBasketContent(proposal);
        });
      }
    }

    return () => {
      document.body.classList.remove('step7');
      const ref = tabsContainerRef.current;

      if (ref) {
        ref.removeEventListener('scroll', () => handleScroll(ref.scrollLeft));
      }
    };
  }, []);

  // componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
  //     const { selectedBasketProposal, tabJ1Name } = this.state;
  //
  //     if (prevState.selectedBasketProposal !== selectedBasketProposal && selectedBasketProposal) {
  //         this.getProductsAndCountsByTab();
  //     }
  //
  //     if (prevState.tabJ1Name !== tabJ1Name && tabJ1Name) {
  //         this.getCenterCordsMap();
  //     }
  // }
  //
  // componentWillUnmount() {
  //     document.body.classList.remove('step7');
  //     const ref = this.tabsContainerRef.current;
  //
  //     if (ref) {
  //         ref.removeEventListener('scroll', () => this.handleScroll(ref.scrollLeft));
  //     }
  // }

  const getBasketContent = (_selectedBasketProposal) => {
    setSelectedBasketProposal(_selectedBasketProposal);
    setBasketLoading(true);

    if (Object.keys(props.proposalsObj || {}).includes(_selectedBasketProposal)) {
      props.actionsJourney
        .getBasketContent({
          basket: props.proposalsObj[_selectedBasketProposal].basket,
          basketreference: props.proposalsObj[_selectedBasketProposal].basketreference,
          group: 'context,format',
          // @ts-expect-error type does not exist
          sortcolumn: currentSort,
          sortdirection: sort[currentSort],
        })
        .then((res) => {
          props.actionsBasket.chooseBasket({
            proposal: props.proposalsObj[_selectedBasketProposal],
            id: _selectedBasketProposal,
          });
          getProductsAndCountsByTab();
          setBasketLoading(false);
        });
    } else {
      setBasketLoading(false);
    }
  };

  const getBaskets = (proposals) => {
    if (proposals && Object.keys(proposals).length > 0) {
      setBasketLoading(true);

      return Promise.all(
        proposals.map((proposal) => {
          return props.actionsJourney
            .getBasketContent({
              basket: proposal.basket,
              basketreference: proposal.basketreference,
              group: 'context,format',
              // @ts-expect-error type does not exist
              sortcolumn: currentSort,
              sortdirection: sort[currentSort],
            })
            .then((basketContentRes) => {
              setBasketLoading(false);
              return basketContentRes;
            });
        }),
      ).then((basketContentsRess) => {
        return proposals;
      });
    } else {
      navigate('/journey1/6');
      return Promise.resolve([]);
    }
  };

  const generateProposals = async (payload) => {
    setLoading(true);

    return props.actionsJourney.postGenerateProposals(payload).then((proposals) => {
      return getBaskets(proposals);
    });
  };

  const prepareProposalOptions = (proposals) => {
    return proposals
      ? Object.keys(proposals).map((proposalKey) => {
          const proposal = props.proposalsObj[proposals[proposalKey].basket];
          return {
            title: proposal.name,
            quantity: proposal.totalcount,
            quantity_text_first: `${proposal.totalcount} ${props.intl.formatMessage({
              id: 'ec.journey01.step07.proposalsMaterial',
              defaultMessage: 'Werbeträger',
            })}`,
            duration: `${proposal.duration} ${props.intl.formatMessage({
              id: 'ec.journey01.step07.proposalsDays',
              defaultMessage: 'Tage',
            })}`,
            countcategories: proposal.countcategories,
            contacts: proposal.contacts,
            target: cutString(proposal.coordinates.map((item) => item.name).join(', '), 35),
            cost: `${formatNumber(proposal.totalsum, 2)} ${props.intl.formatMessage({
              id: 'ec.journey01.step07.proposalsExcluding',
              defaultMessage: '(exkl. MwSt.)',
            })}`,
            value: proposal['basket'].toString(),
          };
        })
      : [];
  };

  const handleProductSelectDeselect = (product, value) => {
    const basketId = props.proposalsObj[selectedBasketProposal].basket;
    const basketreference = props.proposalsObj[selectedBasketProposal].basketreference;
    const payload = {
      entries: [product.basketentryid],
      basket: basketId,
      basketreference: basketreference,
      state: value ? 0 : -1,
    };
    return props.actionsJourney.selectOrDeselect(payload);
  };

  const getProductUrnStrBasket = () => {
    const { userDataEC } = props;

    if (userDataEC && userDataEC.chosenBasketProducts && userDataEC.chosenBasketProducts.products) {
      const res = [];

      userDataEC.chosenBasketProducts.products.forEach((product) => {
        if (product.state !== -1) {
          res.push(product.producturn);
        }
      });

      return res.join('-');
    }

    return [];
  };

  const formatRadius = (product) => {
    const userDataEC = props.userDataEC;
    let radius;

    if (
      userDataEC &&
      !!(userDataEC.locations && userDataEC.locations[replaceUmlauts(product.groupvalue)]) &&
      userDataEC.locations[replaceUmlauts(product.groupvalue)].circle
    ) {
      radius = userDataEC.locations[replaceUmlauts(product.groupvalue)].circle.radius;
    }

    if (!!radius) {
      const a = radius / 1000;

      if (Math.floor(a) == 0) {
        return radius.toFixed(0) + ' m';
      }

      return Number(a.toFixed(1)) + ' km';
    }

    return null;
  };

  const isTabSelected = (tab) => tab === tabJ1;

  const getProductsAndCountsByTab = () => {
    const { baskets } = props;
    const products = baskets ? baskets[selectedBasketProposal]?.groupedproducts?.elements : null;
    let newProductTabsElements = {};

    if (products && products.length > 0) {
      products.forEach((element) => {
        const elements = element.subgroup.elements;

        !!elements &&
          elements.length > 0 &&
          elements.forEach((el: any) => {
            newProductTabsElements[element.groupvalue] = el.products.reduce(
              (acc, el) => {
                if (el.producturn) {
                  acc[el.producturn] = el;
                }

                return acc;
              },
              { ...newProductTabsElements[element.groupvalue] },
            );
          });
      });
    }

    const ref = tabsContainerRef.current;
    if (baskets[selectedBasketProposal]?.groupedproducts?.elements) {
      setProductTabsElements(newProductTabsElements);
      setTabJ1Name(products[0].groupvalue);
      setTabsScroll({
        scrollWidthParent: ref.offsetParent.scrollWidth,
        scrollWidth: ref.scrollWidth,
        scrollLeft: ref.scrollLeft,
      });
      getCenterCordsMap(newProductTabsElements, products[0].groupvalue);
    }
  };

  const getCenterCordsMap = (_productTabsElements, _tabJ1Name) => {
    const products = !!_productTabsElements && _tabJ1Name ? _productTabsElements[_tabJ1Name] : {};
    const firstProduct = (!!products ? Object.values(products)[0] : {}) as any;

    if (firstProduct && firstProduct.latitude && firstProduct.longitude) {
      setCenterCordsMap({
        lat: firstProduct.latitude,
        lng: firstProduct.longitude,
      });
    }
  };

  const handleScroll = (scrollLeft) => {
    setTabsScroll({ ...tabsScroll, scrollLeft });
  };

  const handleClickArrow = (side: string) => {
    const ref = tabsContainerRef.current;

    if (ref) {
      const scrollLeft = ref.scrollLeft;
      const left = side === 'right' ? scrollLeft + 100 : scrollLeft - 100;

      handleScroll(left);
      ref.scrollTo({ top: 0, left, behavior: 'smooth' });
    }
  };

  const {
    baskets,
    proposalsError,
    userDataEC: { chosenBasketProducts, possibleFormats },
  } = props;
  const proposalOptions = prepareProposalOptions(props.proposals);
  const products = baskets ? baskets[selectedBasketProposal]?.groupedproducts?.elements : null;
  // const totalPrice = baskets ? formatNumber(baskets[selectedBasketProposal]?.summary?.mediasum, 2) : 0;
  // const totalGewahlteFlachen = baskets ? baskets[selectedBasketProposal]?.summary?.mediacount : 0;

  return (
    <div className='step7'>
      {!loading ? (
        <div>
          <div className='header'></div>

          <div className='d-flex mt-48'>
            <PackagesInput
              labels={{
                quantity: props.intl.formatMessage({
                  id: 'ec.journey01.step07.quantity',
                  defaultMessage: 'Anzahl',
                }),
                duration: props.intl.formatMessage({
                  id: 'ec.journey01.step07.duration',
                  defaultMessage: 'Dauer',
                }),
                target: props.intl.formatMessage({
                  id: 'ec.journey01.step07.target',
                  defaultMessage: 'Zielgruppe',
                }),
                cost: props.intl.formatMessage({
                  id: 'ec.journey01.step07.cost',
                  defaultMessage: 'Kosten',
                }),
              }}
              options={proposalOptions}
              selected={selectedBasketProposal}
              onChange={getBasketContent}
            />
          </div>

          {baskets && baskets[selectedBasketProposal] && !basketLoading && (
            <div className='d-flex mt-3'>
              <div className='col d-flex justify-content-end my-48'>
                <div>
                  <div className='both-btn'>
                    <Button
                      className={mapView ? 'inactive' : 'active'}
                      buttonType={EButtonType.BasicLink}
                      onClick={() => setMapView(false)}
                    >
                      <ListIcon className='me-3' />
                      <FormattedMessage id='ec.components.buttons.listView' defaultMessage='Liste' />
                    </Button>
                    <Button
                      className={mapView ? 'active' : 'inactive'}
                      buttonType={EButtonType.BasicLink}
                      onClick={() => setMapView(true)}
                    >
                      <LocationIcon className='me-3' />
                      <FormattedMessage id='ec.components.buttons.mapView' defaultMessage='Karte' />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className='products-table-tabs'>
            <div className='col-9 col-lg-8 d-flex product-tabs-block'>
              {tabsScroll.scrollWidth > 0 &&
                tabsScroll.scrollWidthParent < tabsScroll.scrollWidth &&
                tabsScroll.scrollLeft > 50 && (
                  <span className={'product-tabs-block__arrow-left'} onClick={() => handleClickArrow('left')}>
                    <IconArrowRight />
                  </span>
                )}

              <div className='d-flex flex-nowrap product-tabs-block__scroll-tabs h-100' ref={tabsContainerRef}>
                {products?.length &&
                  products.map((product, idx) => (
                    <div
                      className={classNames('products-table-tab', {
                        selected: isTabSelected(idx),
                      })}
                      onClick={() => {
                        setTabJ1(idx);
                        setTabJ1Name(product.groupvalue);
                      }}
                    >
                      <div className='row d-flex align-content-center justify-content-start flex-nowrap'>
                        <div className='icon-flaschen w-auto'>
                          <IconTarget />
                        </div>

                        <p className='city-flaschen fw-bold'>
                          {product.groupvalue}
                          {defined(formatRadius(product)) ? (
                            <>
                              &nbsp;({formatRadius(product)}
                              <FormattedMessage id='ec.journey02.step06.radius' defaultMessage=' Radius' />)
                            </>
                          ) : null}
                        </p>
                      </div>

                      <p className='mini-city-flaschen'>
                        {product.count} <FormattedMessage id='ec.journey02.step06.flachen' defaultMessage='Flächen' />
                      </p>
                    </div>
                  ))}
              </div>

              {tabsScroll.scrollWidth > 0 &&
                tabsScroll.scrollWidthParent + tabsScroll.scrollLeft - 50 < tabsScroll.scrollWidth && (
                  <span className={'product-tabs-block__arrow-right'} onClick={() => handleClickArrow('right')}>
                    <IconArrowRight />
                  </span>
                )}
            </div>
          </div>

          {mapView && productTabsElements[tabJ1Name] ? (
            <div className='mapContainer'>
              {centerCordsMap && (
                <MapContainer
                  center={centerCordsMap}
                  zoom={15}
                  handleProductSelectClick={(product, value) => handleProductSelectDeselect(product, value)}
                  availableAttributes={props.availableAttributesJ1}
                  intl={props.intl}
                  overviewJ1
                  actionsJourney1={props.actionsJourney}
                  locations={productTabsElements[tabJ1Name]}
                  productUrnStrBasket={getProductUrnStrBasket()}
                  useCustomMarker
                />
              )}
            </div>
          ) : (
            <div className='d-flex flex-column mt-3'>
              {basketLoading && (
                <SpinnerV2
                  headerText={props.intl.formatMessage({
                    id: 'ec.journey01.step07.spinnerHeaderText',
                    defaultMessage: 'Bitte haben Sie einen Moment Geduld.',
                  })}
                  text={props.intl.formatMessage({
                    id: 'ec.journey01.step07.spinnerTextReservingBasket',
                    defaultMessage: 'Wir stellen Ihnen nun mögliche Empfehlungen zusammen.',
                  })}
                />
              )}

              {baskets &&
                !basketLoading &&
                baskets[selectedBasketProposal] &&
                baskets[selectedBasketProposal].groupedproducts && (
                  <ProductsTable
                    onChange={() => null}
                    currentSort={currentSort}
                    sort={sort}
                    sortChanged={(sortName) => {
                      setSort({
                        ...sort,
                        [sortName]: sort[sortName] ? 0 : 1,
                      });
                      setCurrentSort(sortName);
                      getBasketContent(selectedBasketProposal);

                      // this.setState(
                      //     {
                      //         sort: {
                      //             ...sort,
                      //             [sortName]: sort[sortName] ? 0 : 1,
                      //         },
                      //         currentSort: sortName,
                      //     },
                      //     () => this.getBasketContent(selectedBasketProposal)
                      // );
                    }}
                    basketId={baskets[selectedBasketProposal].basket}
                    basketEntries={chosenBasketProducts?.productsByUrn || null}
                    handleProductSelectClick={(product, value) => handleProductSelectDeselect(product, value)}
                    productsNested={baskets[selectedBasketProposal].groupedproducts.elements || null}
                    userDataEC={props.userDataEC}
                    tabJ1={tabJ1}
                    onRemoveCallback={() => getBaskets(props.proposals)}
                    isHideAddingRemoval={true}
                  />
                )}
            </div>
          )}

          {selectedBasketProposal === null && proposalsError ? proposalsError.map((error) => <p>{error}</p>) : null}

          <div className='d-flex twoButtons mt-5'>
            <Button
              onClick={() => {
                const prevStep =
                  possibleFormats && possibleFormats.data && possibleFormats.data.digital != 1 ? '5' : '6';
                navigate({ pathname: `/journey1/${prevStep}` });
              }}
              buttonType={EButtonType.InvertedPillMedium}
            >
              <FormattedMessage id='ec.components.buttons.back' defaultMessage='Zurück' />
            </Button>

            <Button
              onClick={() =>
                navigate({
                  pathname: '/journey1/8',
                })
              }
              buttonType={EButtonType.PillMedium}
              className={'ms-3'}
            >
              <FormattedMessage id='ec.components.buttons.next' defaultMessage='Weiter' />
            </Button>
          </div>
        </div>
      ) : (
        <SpinnerV2
          headerText={props.intl.formatMessage({
            id: 'ec.journey01.step07.spinnerHeaderText',
            defaultMessage: 'Bitte haben Sie einen Moment Geduld.',
          })}
          text={props.intl.formatMessage({
            id: 'ec.journey01.step07.spinnerTextReservingBasket',
            defaultMessage: 'Wir stellen Ihnen nun mögliche Empfehlungen zusammen.',
          })}
        />
      )}
    </div>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsJourney: bindActionCreators(_actionsJourney as any, dispatch),
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    dispatch,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Step7)));
